module.exports = __webpack_public_path__ + "img/id8.05c35f45.png";